module.exports = __webpack_public_path__ + "static/media/vk.ff4d34be.svg";